module.exports = __webpack_public_path__ + "media/img/event/Virtual-Scholarship-Fair-2020-Feature-Layer-05-d702c9f2c4b830e3a808c57305f17d98.svg";